import axios from 'axios';

const GEMINI_API_KEY = import.meta.env.VITE_GOOGLE_GEMINI_API_KEY;
const GEMINI_API_URL = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent';

interface GenerateTextRequest {
  script: string;
  language: string;
  duration: string;
}

export async function generateSceneDescriptions(req: GenerateTextRequest) {
  try {
    const prompt = `أنت كاتب سيناريو محترف. حول هذا النص إلى وصف مشاهد تفصيلي لفيديو:

النص: ${req.script}

المطلوب:
- اكتب 5-10 وصف مشهد قصير وواضح
- كل مشهد يجب أن يكون قابل للتصوير
- اللغة: ${getLanguageName(req.language)}
- المدة: ${req.duration}

الرد: (قائمة أرقام فقط)`;

    const response = await axios.post(
      `${GEMINI_API_URL}?key=${GEMINI_API_KEY}`,
      {
        contents: [
          {
            parts: [
              {
                text: prompt,
              },
            ],
          },
        ],
      }
    );

    const text =
      response.data.candidates?.[0]?.content?.parts?.[0]?.text || '';
    return parseScenes(text);
  } catch (error) {
    console.error('Error generating scenes:', error);
    return getDefaultScenes();
  }
}

export async function generateVoiceScript(req: GenerateTextRequest) {
  try {
    const prompt = `أنت مذيع احترافي. حول هذا النص إلى سيناريو صوتي:

النص: ${req.script}

المطلوب:
- اكتب نصاً واضحاً للتعليق الصوتي
- اللغة: ${getLanguageName(req.language)}
- يجب أن يكون ملائماً للمشاهد البصرية

الرد: (النص مباشرة)`;

    const response = await axios.post(
      `${GEMINI_API_URL}?key=${GEMINI_API_KEY}`,
      {
        contents: [
          {
            parts: [
              {
                text: prompt,
              },
            ],
          },
        ],
      }
    );

    return response.data.candidates?.[0]?.content?.parts?.[0]?.text || req.script;
  } catch (error) {
    console.error('Error generating voice script:', error);
    return req.script;
  }
}

function getLanguageName(code: string): string {
  const languages: Record<string, string> = {
    ar: 'العربية',
    en: 'English',
    fr: 'Français',
    es: 'Español',
  };
  return languages[code] || 'العربية';
}

function parseScenes(text: string): string[] {
  return text
    .split('\n')
    .filter((line) => line.trim())
    .slice(0, 10)
    .map((line) => line.replace(/^\d+\.\s*/, '').trim());
}

function getDefaultScenes(): string[] {
  return [
    'مشهد تمهيدي جميل مع موسيقى خلفية',
    'عرض النقاط الرئيسية بشكل متسلسل',
    'مشاهد توضيحية مثيرة للاهتمام',
    'تركيز على التفاصيل المهمة',
    'انتقال سلس بين المشاهد',
    'خاتمة مؤثرة وملهمة',
  ];
}
